import {FC, useState} from "react";
import OpenLinkIcon from "../../../assets/icons/world_src.svg";
import LinkIcon from "../../../assets/icons/link.svg";
import BluePlusIcon from "../../../assets/icons/plus-svgrepo-blue.svg";
import {ImageWrapper, MinusIcon, Title} from "../stylesCases";
import {ICase} from "../../../pages/Fintech/FintechDashboard.type";
import {getDomainFromUrl} from "../../../helper/functions";

interface Iprops {
  dataItem: ICase;
  isOpen?: boolean;
}

export const CaseItemWeakSignal: FC<Iprops> = ({dataItem, isOpen = false}) => {
  const [isActive, setIsActive] = useState(isOpen);

  const handleToggle = () => {
    setIsActive((prev) => !prev);
  };

  return (
    <div>
      <div
        style={{
          alignItems: "center",
          display: "grid",
          gridTemplateColumns: "25fr 1fr",
          marginTop: "1rem",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "0.5fr 10fr",
            alignItems: "center",
          }}
        >
          <img src={LinkIcon} alt="Link" />
          {dataItem.name !== null ? (
            <Title
              style={{
                fontWeight: "700",
                textTransform: "uppercase",
              }}
            >
              {dataItem.name}
            </Title>
          ) : (
            <div
              style={{
                color: "#FFFFFF",
                lineHeight: "17.9px",
                whiteSpace: "pre-wrap",
              }}
            >
              {dataItem.desc}
            </div>
          )}
        </div>
        {dataItem.name !== null && (
          <ImageWrapper
            onClick={handleToggle}
            style={{
              width: "17px",
              height: "17px",
              border: "1px solid #71C6FA",
              borderRadius: "50%",
              margin: "0 auto",
            }}
          >
            {isActive ? (
              <MinusIcon
                style={{width: "8px", border: "0.75px solid #71C6FA"}}
              />
            ) : (
              <img src={BluePlusIcon} style={{width: "1rem"}} alt="Open link" />
            )}
          </ImageWrapper>
        )}
      </div>
      {isActive && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "0.5fr 10fr",
            margin: "0.5rem 0",
          }}
        >
          <div></div>
          <div>
            <div
              style={{
                color: "#FFFFFF",
                lineHeight: "17.9px",
                whiteSpace: "pre-wrap",
              }}
            >
              {dataItem.name !== null && dataItem.desc}
            </div>
          </div>
        </div>
      )}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "0.5fr 10fr",
          margin: "0.5rem 0",
        }}
      >
        <div></div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            color: "#FFFFFF",
            margin: "0.25rem 0",
          }}
        >
          <img src={OpenLinkIcon} alt="Open link" />
          <a
            target="_blank"
            rel="noreferrer"
            href={dataItem.url}
            style={{textDecoration: "none", color: "#71C6FA", fontSize: "12px"}}
          >
            {getDomainFromUrl(dataItem.url)}
          </a>
        </div>
      </div>
    </div>
  );
};
